import { advanceTask } from './advanceTask'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, registerJob } from './jobs'
import { createTask_constructHull } from './taskConstructHull'
import { createConsumeCargoTask } from './taskConsumeCargo'
import { createTask_deliverCargo } from './taskDeliverCargo'
import { createTask_enterShip } from './taskEnterShip'
import { createFetchCargoTask } from './taskFetchCargo'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'

export const register = () =>
  registerJob('construct-hull', advanceJob_constructHull)

export function advanceJob_constructHull(job: IJob) {
  jobLogger.assertJobType(job, 'construct-hull')

  let bp = jobLogger.assertBlueprint(job)
  let m = jobLogger.assertReserved(job)

  // Seed job tasks
  if (job.tasks.length === 0) {
    job.isFailed = false
    job.tasks = []

    // Get cargo
    let task = createFetchCargoTask(m.i, m.j, null, 'steel', true)
    job.tasks.push(task)

    let std = tilesDataShip.getStandard()
    let isInsideShip = bp.tileData === std.tube

    // Go to blueprint
    task = createTask_deliverCargo(bp.i, bp.j, 'steel', isInsideShip)
    job.tasks.push(task)

    // Construct
    task = createConsumeCargoTask(bp.i, bp.j, 'steel')
    job.tasks.push(task)
    task = createTask_constructHull(bp.i, bp.j)
    job.tasks.push(task)

    // // Go inside
    // task = createTask_enterShip(m.i, m.j)
    // job.tasks.push(task)

    return
  }

  if (job.tasks.length > 0) {
    advanceTask(job)
  }
}
